'use strict';
const trackingUtils = require('../../modules/utils/tracking.utils');
const actions = require('../../modules/secure_store/actions');
import {dispatch} from 'od-modules/secure_store/store';

export default Odigeo.Model.extend({
    productSelectionError: 'INT-003',
    changePersonalInfoError: 'WNG_050',
    dataURL: null,
    dataURLAddProduct: 'addproduct',
    dataURLPersonalInfo: 'addpersonalinfo',
    dataURLSubmitProducts: 'submitproducts',
    CONST: {
        NO_INTENTION: 'NOT_INTENTED_PURCHASE',
        INTENTION_UNFULFILLED: 'INTENDED_PURCHASE',
        INTENTION_FULFILLED: 'PURCHASED',
    },

    // method overriden from Odigeo
    getDataRequestSettings: function() {
        return {
            type: 'POST',
            data: JSON.stringify(this._formatRequestData()),
            contentType: 'application/json',
            dataType: 'json',
            cache: false,
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        };
    },

    _formatRequestData: function() {
        var bookingID = String(this.get('bookingID'));
        var nextPage = String(this.get('nextPage'));
        var pageToGo = String(this.get('pageToGo'));
        var bookingPaxList = [];
        var hasPassengerInfo = false;
        var hasProductsInfo = false;
        var resultSchema = {};
        var passResultSchema = {
            'travellers': [],
            'buyer': {},
            'bookingId': bookingID,
            'nextPage': nextPage,
            'pageToGo': pageToGo,
            'refundableFareUpgradeShown': this.get('refundableFareUpgradeShown') || false,
            'refundableFareUpgrade': this.get('refundableFareUpgrade') || false,
            'customerInteractionWithBaggage': this.getIntentionToBuy('bags'),
        };
        var prodResultSchema = {
            'insuranceOffers': [],
            'serviceOptions': {},
            'bookingId': bookingID,
            'promotionalCodes': [],
            'nextPage': nextPage,
            'pageToGo': pageToGo,
        };
        var data = this.get('data');

        Odigeo._.each(data, function(obj, key) {
            if (key.indexOf('passenger') >= 0) {
                passResultSchema.travellers.push(obj);
                bookingPaxList.push(obj);
                hasPassengerInfo = true;
            } else if (key.indexOf('buyer') >= 0) {
                passResultSchema.buyer = obj;
                hasPassengerInfo = true;
            } else if (key.indexOf('insurance') >= 0) {
                if (key === 'insurancesToAdd') {
                    passResultSchema.insurancesToAdd = Odigeo._.isUndefined(obj) ? '' : obj;
                } else {
                    prodResultSchema.insuranceOffers = obj;
                    hasProductsInfo = true;
                }
            } else if (key.indexOf('serviceoptions') >= 0) {
                prodResultSchema.serviceOptions = obj;
                hasProductsInfo = true;
            } else if (key.indexOf('seats') >= 0) {
                Odigeo._.extend(passResultSchema, {seatSelectionsRequestDTO: obj});
            } else if (key.indexOf('boardingOptions') >= 0) {
                Odigeo._.extend(passResultSchema, {
                    boardingOptions: obj,
                });
            }
        }, this);

        if (hasPassengerInfo && hasProductsInfo) {
            Odigeo.Session.set('booking_pax_list', JSON.stringify(bookingPaxList));
            resultSchema.personalInfoRequest = passResultSchema;
            resultSchema.productInfoRequest = prodResultSchema;
        } else if (hasPassengerInfo) {
            Odigeo.Session.set('booking_pax_list', JSON.stringify(bookingPaxList));
            resultSchema = passResultSchema;
        } else if (hasProductsInfo) {
            resultSchema = prodResultSchema;
            if (data.removeAncillaryServices) {
                resultSchema = Odigeo._.extend(resultSchema, {removeAncillaryServices: true});
            }
        }

        return resultSchema;
    },

    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataURL);
    },

    updateSessionValue(currentId, newId, value) {
        const baggagesSelection = Odigeo.Utils.parseJson(Odigeo.Session.get(value)) || {};
        if (baggagesSelection[currentId]) {
            baggagesSelection[newId] = baggagesSelection[currentId];
            Odigeo.Session.set(value, JSON.stringify(baggagesSelection));
        }
    },

    updateSessionSeats(currentId, newId) {
        const currentSelection = Odigeo.Session.get('seatSelection_' + currentId);
        if (currentSelection) {
            Odigeo.Session.set('seatSelection_' + newId, currentSelection);
        }
    },

    updateSessionAncillaries({currentId, newId}) {
        if (currentId !== newId) {
            this.updateSessionValue(currentId, newId, 'baggagesSelection');
            this.updateSessionSeats(currentId, newId);
            this.updateSessionValue(currentId, newId, 'boardingOptionSelection');
        }
    },

    requestSuccessHandler: function(msg) {
        Odigeo.trigger(this.widget.id + ':enablePaymentButton');
        if (msg.errors !== null) {
            this.handleErrorMessages(msg);
        } else {
            dispatch({type: actions.SET_SHOPPING_CART, entry: msg.shoppingCartDTO});
            dispatch({type: actions.SET_USER_STATUS, entry: msg.userTypeDTO});
            dispatch({type: actions.SET_MEMBERSHIP_SUBSCRIPTION_OFFER, entry: msg.membershipSubscriptionDetailsDTO});
            dispatch({type: actions.SET_MEMBERSHIP_DISCOUNT, entry: msg.shoppingCartDTO.membershipPerksDTO});
            Odigeo.Session.set('bookingId', msg.bookingId);
            Odigeo.trigger(this.widget.id + ':requestCompletedSuccessfully', msg);
        }
    },

    handleErrorMessages: function(msg) {
        const errorMessage = msg.errors[0].message;
        const errorCode = msg.errors[0].code;
        const currentId = parseInt(this.get('bookingID'), 10);
        const newId = Odigeo._.get(msg, 'bookingId');

        if (Odigeo.Utils.startsWith(errorMessage, this.productSelectionError)) {
            trackingUtils.trackEvent('back_and_errors', `user_cant_continue_popup_${errorMessage}`);
            Odigeo.UIElements.showBrokenFlowError();
        } else if (Odigeo._.isEqual(errorCode, this.changePersonalInfoError)) {
            this.updateSessionAncillaries({currentId, newId});
            trackingUtils.trackEvent('back_and_errors', `personal_info_change_discrepancy_${errorCode}`);
            Odigeo.Router.reload();
        } else {
            Odigeo.trigger(`${this.widget.id}:requestCompletedWithError`, msg.errors);
        }
    },
    // TODO refactor this with events for tablet.handler as in flights manager
    _hideContainersForError: function() {
        $('#bread-crumbs').addClass('hidden');
    },
    requestErrorHandler: function(xhr) {
        const errors = Odigeo._.get(xhr, 'responseJSON.errors');
        if (errors) {
            this.handleErrorMessages({errors});
        } else {
            Odigeo.trigger(`${this.widget.id}:requestError`, xhr);
        }
    },
    addProductToShoppingCart: function(params) {
        var keys;
        this.set({'bookingID': params.bookingID});
        this.set({'data': params.data});
        this.set({'nextPage': params.nextPage});
        this.set({'pageToGo': params.pageToGo});

        // Get URL to call
        keys = Odigeo._.keys(this.get('data'));

        this.dataURL = Odigeo._.reduce(keys, function(memo, key) {
            if (key.indexOf('passenger') >= 0 || key.indexOf('buyer') >= 0 || key === 'insurancesToAdd') {
                if (memo === this.dataURLAddProduct) {
                    memo = this.dataURLSubmitProducts;
                } else if (!memo) {
                    memo = this.dataURLPersonalInfo;
                }
            } else if (key.indexOf('insurance') >= 0) {
                if (memo === this.dataURLPersonalInfo) {
                    memo = this.dataURLSubmitProducts;
                } else if (!memo) {
                    memo = this.dataURLAddProduct;
                }
            } else if (key.indexOf('serviceoptions') >= 0) {
                if (memo === this.dataURLPersonalInfo) {
                    memo = this.dataURLSubmitProducts;
                } else if (!memo) {
                    memo = this.dataURLAddProduct;
                }
            } else if (key.indexOf('invoicemanager') >= 0) {
                if (memo === this.dataURLAddProduct) {
                    memo = this.dataURLSubmitProducts;
                } else if (!memo) {
                    memo = this.dataURLAddProduct;
                }
            } else if (key.indexOf('seats') >= 0) {
                if (memo === this.dataURLPersonalInfo) {
                    memo = this.dataURLPersonalInfo;
                } else if (!memo) {
                    memo = this.dataURLAddProduct;
                }
            }
            return memo;
        }, '', this);

        this.isEmptyData = false;
    },
    submitProducts: function() {
        // This will only work if you execute first to addProductToShoppingCart
        this.refresh();
    },
    clearShoppingCart: function() {
        this.clear();
        this.dataURL = null;
        this.isEmptyData = true;
    },
    deleteHotelFromCart: function(isChangeHotel) {
        return this.fetch({
            url: Odigeo.Settings.getProperty('serviceUrlFormatter')('upsell/accommodation'),
            contentType: 'application/json',
            type: 'DELETE',
            parse: false,
            success: Odigeo._.bind(this.successFetchDelete, this, isChangeHotel),
            error: Odigeo._.bind(this.errorFetchDelete, this),
        });
    },
    successFetchDelete: function(isChangeHotel) {
        Odigeo.trigger(this.widget.id + ':successDeleteHotelFromCart', isChangeHotel);
        return this;
    },

    errorFetchDelete: function() {
        Odigeo.trigger(this.widget.id + ':errorDeleteHotelFromCart');
        return this;
    },
    selectFareUpgrade: function() {
        this.set('refundableFareUpgrade', true);
    },
    deleteFareUpgrade: function() {
        this.set('refundableFareUpgrade', false);
    },
    setRefundableFareUpgradeShown: function() {
        this.set('refundableFareUpgradeShown', true);
    },
    getIntentionToBuy(product) {
        const numSelection = Odigeo._.parseInt(Odigeo.Session.get(`numSelected_${product}`) || 0);
        const intentionToBuy = Odigeo.Utils.parseJson(Odigeo.Session.get(`intentionToBuy_${product}`));
        const intentionResult = numSelection > 0 ?
            this.CONST.INTENTION_FULFILLED : this.CONST.INTENTION_UNFULFILLED;

        return intentionToBuy ? intentionResult : this.CONST.NO_INTENTION;
    },
});
